angular.module("dx.webapp.event", [
	"digiexam.services",
	"dx.webapp.roles",
]);
